import { NgModule } from '@angular/core';
import { DxMenuModule, DxButtonModule, DxSelectBoxModule, DxTooltipModule,
     DxTextAreaModule, DxListModule, DxFormModule, DxDateBoxModule, DxCheckBoxModule, 
    DxDataGridModule, DxDropDownBoxModule, DxTreeListModule, DxPopupModule, DxToastModule, DxTextBoxModule, DxTreeViewModule } from 'devextreme-angular';
import { DxoHeaderFilterModule } from 'devextreme-angular/ui/nested';

@NgModule({
	imports: [
        DxMenuModule,
        DxButtonModule,
        DxSelectBoxModule,
        DxTooltipModule,
        DxButtonModule,
        DxTextAreaModule,
        DxDateBoxModule,
        DxFormModule,
        DxListModule,
        DxCheckBoxModule,
        DxDateBoxModule,
        DxDataGridModule,
        DxDropDownBoxModule,
        DxTreeListModule,
        DxTreeViewModule,
        DxPopupModule,
        DxoHeaderFilterModule,
        DxToastModule,
        DxTextBoxModule
    ],
	exports: [
        DxMenuModule,
        DxButtonModule,
        DxSelectBoxModule,
        DxTooltipModule,
        DxButtonModule,
        DxTextAreaModule,
        DxDateBoxModule,
        DxFormModule,
        DxListModule,
        DxCheckBoxModule,
        DxDateBoxModule,
        DxDataGridModule,
        DxDropDownBoxModule,
        DxTreeListModule,
        DxTreeViewModule,
        DxPopupModule,
        DxoHeaderFilterModule,
        DxToastModule,
        DxTextBoxModule
    ]
}) 
export class HhsgSharedDevExtremeModule {
}
